import React, {useEffect, useState} from "react";
import {SalesDocumentService} from "../../../api/services/ntsWebappService";
/**
 * Documents download in SalesTools page under SalesTool Nav bar object
 *
 * sales_document.json
 *  Description: Describes links to be displayed in Sales Tools page
 *  Location: {akamai}/.../niketeam-asset-download/guides/sales/sales_document.json
 *  Format:
 *      { display: "document display name", url: "link to file", (optional) target: "_blank" }
 */
export const SalesToolsPage = () => {

    const [salesDocuments, setSalesDocuments] = useState([]);

    useEffect(() => {
        fetchSalesDocuments();
    }, []);

    const fetchSalesDocuments = async () => {
        const data = await SalesDocumentService.getSalesDocumentConfig()
            .catch((e) => console.error('Error fetching sales documents', e));
        if (data) {
            setSalesDocuments(data.documents);
        }
    };

  return (

      <div className="container nts-faq-help-page">

        <div className="nts-faq-title-bar row">
          <div className="col-xs-12">
            <h1>SALES TOOLS</h1>
          </div>
        </div>

        <div className="nts-faq-container topic-container">
          <h1 className="nts-faq-container-title">DOCUMENTS</h1>
          <div className="nts-faq-topic-content" data-nts-qa="salesToolsPage.documents.links">
              {salesDocuments && salesDocuments.length > 0 && salesDocuments.map((doc, i) => (
                  <a href={doc.url} key={i} rel="noreferrer" className="nts-faq-sales-doc" {...(doc.target ? {target:doc.target} : '')}>{doc.display}</a>
              ))}
          </div>
        </div>

      </div>

  );

};

export default SalesToolsPage;
